import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            GET /messages/{"{"}messageId{"}"}
          </h1>
        </div>
        <p>Get the message object by its ID.</p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>messageId</td>
                <td>The ID of the message</td>
                <td>Path</td>
                <td>Yes</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer and PERM_TOPIC_READ</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          GET https://spacesapis.avayacloud.com/api/messages/{"{"}messageId{"}"}
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {`
          {
            "sender": {
                "_id": "5f04251caa4a347af9946e06",
                "username": "test@user.com",
                "displayname": "Test User",
                "picture_url": "https://storage.googleapis.com/onesna/pictures/pfpic_test_34cb97bd-0151-449d-84b0-48e07853b49f",
                "type": "user"
            },
            "content": {
                "endTime": null,
                "mediaMode": "audio",
                "virtualEndTime": null,
                "meetingStatus": "active",
                "bodyText": "",
                "data": [
                    {
                        "metaData": {
                            "paging": 0,
                            "prvwProvd": "gcs",
                            "stgeProvd": "gcs"
                        },
                        "keywords": [],
                        "convertStatus": 0,
                        "convertStart": null,
                        "nextSchedule": null,
                        "pages": 0,
                        "recordingId": null,
                        "type": null,
                        "provider": "native",
                        "providerFileType": "image/png",
                        "fileType": "image",
                        "name": "117528853_613451505859835_4093766307432132389_n.png",
                        "fileId": "15ec01bd-5611-4bb5-b4cb-1c717a09a085",
                        "icon": "",
                        "thumbnail": "",
                        "description": "",
                        "previewFile": "",
                        "fileSize": 116735,
                        "thumbnailFile": "3e3341ca-8fe2-4ffc-8792-e9e9ea77372f",
                        "previewUrl": "https://storage.googleapis.com/spaces2020/logan%2F3e3341ca-8fe2-4ffc-8792-e9e9ea77372f?GoogleAccessId=spaces2020@spaces-2018.iam.gserviceaccount.com&Expires=1597142903&Signature=hbiMr9gn4JqvfQ0Wwjc58u9C5LyEZcNf1GmYiiTRPdp4DAj57ENv%2Bfv2w1xulhw5xtziEhe7SXQuFKX9AXEPPOkI0xpx3O4wrghcxzHHuHw6kO2urcQCU3Td2DXkVNZR2WZbcf9DHx96JpAk9GGPAJbSJRLHk%2BI7m7DdPQj8iJl0aVa0zVnEl0a3MM0H0Gaf1Wrrrk5w4weXIbfNwjGUnpT0TiUY7LLxF3VAdQs5YEXve33pplF1lwQPjIrfD5TXDNoP5ubUoZptq44hFye7523oXQUEskvaiBWWu1vCty6LxT7f1UEsu2P72Izn4uvjqdIFvkThAtM%2F7hxfCqZNOg%3D%3D",
                        "thumbnailUrl": "https://storage.googleapis.com/spaces2020/logan%2F3e3341ca-8fe2-4ffc-8792-e9e9ea77372f?GoogleAccessId=spaces2020@spaces-2018.iam.gserviceaccount.com&Expires=1597142903&Signature=hbiMr9gn4JqvfQ0Wwjc58u9C5LyEZcNf1GmYiiTRPdp4DAj57ENv%2Bfv2w1xulhw5xtziEhe7SXQuFKX9AXEPPOkI0xpx3O4wrghcxzHHuHw6kO2urcQCU3Td2DXkVNZR2WZbcf9DHx96JpAk9GGPAJbSJRLHk%2BI7m7DdPQj8iJl0aVa0zVnEl0a3MM0H0Gaf1Wrrrk5w4weXIbfNwjGUnpT0TiUY7LLxF3VAdQs5YEXve33pplF1lwQPjIrfD5TXDNoP5ubUoZptq44hFye7523oXQUEskvaiBWWu1vCty6LxT7f1UEsu2P72Izn4uvjqdIFvkThAtM%2F7hxfCqZNOg%3D%3D",
                        "path": "https://storage.googleapis.com/spaces2020/logan%2F15ec01bd-5611-4bb5-b4cb-1c717a09a085?GoogleAccessId=spaces2020@spaces-2018.iam.gserviceaccount.com&Expires=1597142903&Signature=P2ClmlxN7B90GitLrKxUUUFsOmULc7wxVp26LaxoUvCejvCF8LAn4UEnithSZQY9cn%2FcN7iVAChe%2BspbSldXLJCG8N4wUyr7vK8PLUAiJX%2B4%2FA6GazwKQZF6jUO6QPf6xVwrByEaFp02SgwdCD5NfMTNdmEhdkxYPOJgno2BmXfpC7gHjvEwFvLLW51GOxAGTma%2BDhTwnKCZRVPg95RMJ4RGsyjYE50%2FJpv6N9pRnKHxzKIgQqQyGgdVU%2FMF1aCPIlVMIUjQOs%2BwEhcjhhCUuXoJyxLzLXekEaQfUk49Ksh8VozTMGkE2XmafTas36UV20ymbmN%2FQcur6WiGoyH0Qg%3D%3D&response-content-disposition=attachment%3B%20filename%3D%22117528853_613451505859835_4093766307432132389_n.png%22"
                    }
                ],
                "description": "",
                "startTime": "2020-08-11T08:48:14.487Z",
                "recordings": []
            },
            "chatCount": 0,
            "likeCount": 0,
            "status": 0,
            "_id": "5f325b4e0656c90a722a3c87",
            "category": "chat",
            "topicId": "5f06c25e574ca36b54cb4cdf",
            "created": "2020-08-11T08:48:14.478Z",
            "modified": "2020-08-11T08:48:14.478Z"
        }`}
        </pre>
      </div>
    </div>
  </Layout>
)
